import type { ConsentField } from '@/modules/iubenda/submitFieldConsents'

import { resolveConsentItemText } from './resolveConsentItemText.ts'
import type { LegalConsentItem } from './types.ts'

/**
 * Builds one iubenda consent field per legal-consent item, reusing each
 * item's own `identifier` as both the internal preference key and the
 * iubenda `legalNoticeIdentifier`. `te` is captured per item so
 * `resolveProofText` — which only ever receives `t`, per the existing
 * `ConsentField` contract — still resolves through the same
 * translated-or-fallback text.
 */
export function buildConsentSubmissionFields(
  items: LegalConsentItem[],
  te: (key: string) => boolean
): ConsentField[] {
  return items.map((item) => ({
    key: item.identifier,
    legalNoticeIdentifier: item.identifier,
    resolveProofText: (t) => resolveConsentItemText(item, t, te),
  }))
}

/**
 * Builds the input array for the `acceptLegalConsents` mutation, reusing
 * `resolveConsentItemText` so the backend's recorded proof text always
 * matches what the iubenda record and the checkbox label show.
 */
export function buildLegalConsentMutationInput(
  items: LegalConsentItem[],
  t: (key: string) => string,
  te: (key: string) => boolean
): { identifier: string; proofText: string }[] {
  return items.map((item) => ({
    identifier: item.identifier,
    proofText: resolveConsentItemText(item, t, te),
  }))
}
